// extracted by mini-css-extract-plugin
module.exports = {"container":"UserCard_container__YXtB5","selectedIndicator":"UserCard_selectedIndicator__vXKq9","statusIndicator":"UserCard_statusIndicator__2HS-q"};